<template>
  <v-app>
    <div v-if="loading" class="loading-screen">
      <img
        class="splash-logo"
        :src="require('@/assets/logo.png')"
        alt="Konvenio"
      >
      <div class="spinner"></div>
    </div>

    <div v-else>
      <router-view />
      <CookieBanner />
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import CookieBanner from '@/components/CookieBanner.vue'

export default {
  name: 'Bootstrap',
  components: {
    CookieBanner
  },
  computed: {
    ...mapGetters('auth', ['authReady']),
    loading() {
      return !this.authReady
    }
  }
}
</script>

<style>
html,
body,
#app {
  max-width: 100%;
  overflow-x: hidden;
}

.loading-screen {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  align-items: center;
  background: white;
  z-index: 9999;
}
.splash-logo {
  width: 128px;
  height: 128px;
  object-fit: contain;
}
.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #3f51b5;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
